<template>
  <div>
    <template v-if="item.children.length === 0">
    <!-- <template v-if="item.children.length === 0 || item.children.every(i => !i.is_menu)"> -->
      <a-menu-item
        class="sider-item"
        :key="item.code"
      >
        <Item :item="item"/>
      </a-menu-item>
    </template>
    
    <!-- <SubMenu v-else :menu="item" /> -->

    <a-sub-menu
      v-else
      :key="item.code"
      :title="item.name">
      {{item.name}}
      <a-menu-item
        class="sider-item"
        v-for="child in item.children"
        :key="child.code"
      >
        <Item :item="child"/>
      </a-menu-item>
    </a-sub-menu>
  </div>
</template>

<script>
import Item from './Item'
import SubMenu from './Submenu'

export default {
  name: 'SidebarItem',
  components: {
    Item,
    SubMenu
  },
  watch: {
    item(val) {
      console.log(val);
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    },
  },
  mounted() {
    console.log(this.item);
  }
}
</script>

<style lang="less" scoped>
.sider-item {
  height: 48px !important;
  line-height: 48px !important;
}
// 选中的menuitem
.ant-menu-item-selected {

}
</style>
